import angular from 'angular'

angular.module('fieldTransformation.services').factory('FieldTransformer', [function () {
    return {
        transformCurrency(val, trimming = true) {
            if (val == null || typeof val !== 'string') {
                console.log('Cannot transform "' + val + '" in a currency')
                return '';
            }

            let sign = val.charAt(0) === '-' ? '-' : '';

            // todo: get currency symbol dynamically
            val = val.replace(/,/g, "");
            if (trimming === true) {
                val = parseFloat(val).toFixed(2);
            }
            var numVal = val.split(".");
            if (numVal.length >= 2) {
                numVal[0] = numVal[0].replace(/[^0-9]/gi, '');
                numVal[1] = numVal[1].replace(/[^0-9]/gi, '');
                numVal[0] = numVal[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                val = numVal[0] + "." + numVal[1];
            } else {
                val = val.replace(/[^0-9]/gi, '');
                val = val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            }

            return sign + "$" + val;
        },
        transformNumber(value, round = 0) {
            if (value == null || typeof value !== 'string') {
                console.log('Cannot transform "' + value + '" in a number')
                return '';
            }

            let sign = value.charAt(0) === '-' ? '-' : '';
            value = value.replace(/,/g, "");
            value = parseFloat(value).toFixed(round);
            var numVal = value.split(".");
            if (numVal.length >= 2) {
                numVal[0] = numVal[0].replace(/[^0-9]/gi, '');
                numVal[1] = numVal[1].replace(/[^0-9]/gi, '');
                numVal[0] = numVal[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                value = numVal[0] + "." + numVal[1];
            } else {
                value = value.replace(/[^0-9]/gi, '');
                value = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            }

            value = sign + value

            return value;
        }
    }
}])